import React from 'react';
import { useTranslation } from 'react-i18next';
import { ISharedUser } from 'types/IEquipmentEntry';
import { ic_more_secondary as MoreIcon } from 'app/widgets/SVGs';
import ClickOutside from 'app/widgets/ClickOutside';
import { Card } from '@progress/kendo-react-layout';
import { Avatar } from 'app/components/Avatar';

interface ISharedWithRow {
  user: ISharedUser;
  isMobile: boolean;
}

function SharedWithRow(props: ISharedWithRow) {
  const [showGeneralMore, setShowGeneralMore] = React.useState(false);
  const { t } = useTranslation();

  return (
    <>
      {!props.isMobile ? (
        <div>
          <div className="access-sharing-table-row shared-with min-w-0">
            <div className="min-w-0">
              <div className="picture-and-description shared-with min-w-0">
                <Avatar
                  email={props.user.email}
                  firstName={props.user.displayName}
                />
                <div className="min-w-0">
                  <div className="equipment-nickname ellipsis-2-lines">
                    {props.user.displayName}
                  </div>
                  <div className="ellipsis">{props.user.email}</div>
                </div>
              </div>
            </div>
            <div className="shared-with-access-to">
              {props.user.sharedEquipments.length} pieces of equipment,{' '}
              {props.user.sharedFleets.length} fleets
            </div>
            <div className="shared-with-access-to">
              {[
                ...props.user.sharedEquipments.map(
                  equipment => equipment.sharedItemDetails.sharedItemLabel,
                ),
                ...props.user.sharedFleets.map(
                  fleet => fleet.sharedItemDetails.sharedItemLabel,
                ),
              ].join(', ')}
            </div>
            <div>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setShowGeneralMore(!showGeneralMore);
                }}
              >
                <MoreIcon />
              </span>
              {showGeneralMore && (
                <span className="notification-more dot-menu-dropdown">
                  <ClickOutside
                    onClickOutside={() => {
                      setShowGeneralMore(false);
                    }}
                  >
                    <div className="dot-menu-dropdown-options">
                      <div>
                        <span onClick={async () => {}}>
                          {t('access_sharing_add_new_user')}
                        </span>
                        <span onClick={() => {}}>{t('view_logs')}</span>
                      </div>
                    </div>
                  </ClickOutside>
                </span>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="access-sharing-table-card shared-with">
          <div className="row picture-and-description shared-with">
            <Avatar
              email={props.user.email}
              firstName={props.user.displayName}
            />
            <div className="col min-w-0">
              <div className="equipment-nickname ellipsis-2-lines">
                {props.user.displayName}
              </div>
              <div className="ellipsis">{props.user.email}</div>
            </div>
          </div>
          <div className="equipment-list-details">
            <div className="row-4">
              <div className="col-xxs-12">
                <Card className="access-sharing-equipment-details">
                  <div className="row">
                    <div className="colored-info">{t('access_to')}</div>
                  </div>

                  <div className="row">
                    <div className="col-xxs-4">
                      <span className="bolded-info">3 equipment</span>
                    </div>
                    <div className="col-xxs-8">
                      <span>
                        {props.user.sharedEquipments
                          .map(
                            equipment =>
                              equipment.sharedItemDetails.sharedItemLabel,
                          )
                          .join(', ')}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xxs-4">
                      <span className="bolded-info">1 fleet</span>
                    </div>
                    <div className="col-xxs-8">
                      <span>
                        {props.user.sharedFleets
                          .map(fleet => fleet.sharedItemDetails.sharedItemLabel)
                          .join(', ')}
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div className="more-details-button">
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setShowGeneralMore(!showGeneralMore);
                }}
              >
                <MoreIcon />
              </span>
              {showGeneralMore && (
                <span className="notification-more dot-menu-dropdown">
                  <ClickOutside
                    onClickOutside={() => {
                      setShowGeneralMore(false);
                    }}
                  >
                    <div className="dot-menu-dropdown-options">
                      <div>
                        <span onClick={async () => {}}>
                          {t('access_sharing_add_new_user')}
                        </span>
                        <span onClick={() => {}}>{t('view_logs')}</span>
                      </div>
                    </div>
                  </ClickOutside>
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SharedWithRow;
